import axios from "axios/index";
import {getAPIUrl} from "@esnpm/node-toolbox";
import Promise from "bluebird";
export const API_NEWSLETTER_OPT_OUT_REQUEST = "API_NEWSLETTER_OPT_OUT_REQUEST";
export const API_NEWSLETTER_OPT_OUT_SUCCESS = "API_NEWSLETTER_OPT_OUT_SUCCESS";
export const API_NEWSLETTER_OPT_OUT_FAILURE = "API_NEWSLETTER_OPT_OUT_FAILURE";

export const api_newsletter_opt_out_request = (options) => {
	return {
		type: API_NEWSLETTER_OPT_OUT_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

export const api_newsletter_opt_out_success = (data) => {
	return {
		type: API_NEWSLETTER_OPT_OUT_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

export const api_newsletter_opt_out_failure = (error) => {
	return {
		type: API_NEWSLETTER_OPT_OUT_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Newsletter.apiNewsletterOptOut
*/
export const apiNewsletterOptOut = (options) =>
	// eslint-disable-next-line no-unused-vars
	(dispatch, getState) => new Promise(
		// eslint-disable-next-line no-unused-vars
		(resolve, reject) => {
			dispatch(api_newsletter_opt_out_request(options));
			const url=getAPIUrl([
				{"url": "/api/newsletter/optout", "parameters": []},
			], options);
			axios({
				method: "get",
				url: url,
				params: {
					OPTIN_HASH: options.OPTIN_HASH,
				},
			}).then(
				(response) => {
					if (response.data.SUCCESSFUL) {
						dispatch(api_newsletter_opt_out_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_newsletter_opt_out_failure(response.data));
						resolve();
					}
				},
				(err) => {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				}
			);
		}
	);
